import React from 'react'
import './ModBorder.css'

/**
 * Компонент обертки с градиентной рамкой
 * @param {Object} props
 * @param {string} [props.className] - Дополнительные CSS классы
 * @param {React.ReactNode} props.children - Дочерние элементы
 * @param {string} [props.radius='20px'] - Радиус скругления углов
 * @param {string} [props.innerContentBgColor='red'] - Цвет фона внутреннего содержимого
 * @param {string} [props.borderColor='white'] - Цвет границы
 */
export default function ModBorder({
  className,
  children,
  radius = '20px',
  innerContentBgColor = 'red',
  borderColorTl = 'var(--m-color-stroke-primary)',
  borderColorBr = 'var(--m-color-stroke-secondary)',
}) {
  const combinedClassName = className ? `mod-border ${className}` : 'mod-border'
  const isButtonBorder = className?.includes('mod-button-border')
  const style = {
    borderRadius: radius,
  }

  // Для ModButton используем CSS переменные с родителя (button)
  // Для других случаев устанавливаем через inline стили
  if (!isButtonBorder) {
    style['--mod-border-color-tl'] = borderColorTl
    style['--mod-border-color-br'] = borderColorBr
    style['--mod-inner-bg'] = innerContentBgColor
  }

  return (
    <div className={combinedClassName} style={style}>
      {children}
    </div>
  )
}
